import { render, staticRenderFns } from "./GlobalSettingUpdate.vue?vue&type=template&id=7256927a"
import script from "./GlobalSettingUpdate.vue?vue&type=script&lang=js"
export * from "./GlobalSettingUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports